import { connect } from 'react-redux';
import BrandConsolidation from './BrandConsolidationBanner';

export const BrandConsolidationBanner = connect(({ system: { siteName, isMobile }, renderOptions: { showConsolidationBanner }}) => ({
  siteName, isMobile, showConsolidationBanner
}), null)(BrandConsolidation);
